import { Avatar } from "@mui/material"

const TextAvatar = ({ text, src }) => {
  const safeText = text && text.length ? text : 'User'

  const stringToColor = (str) => {
    let hash = 0
    let i

    for (i = 0; i < str.length; i += 1) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash)
    }

    let color = "#"

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff
      color += `00${value.toString(16)}`.slice(-2)
    }

    return color
  }

  const hasImage = Boolean(src)

  return (
    <Avatar
      key={src || 'default'} // Force re-render when src changes
      src={src}
      sx={{
        backgroundColor: hasImage ? 'transparent' : stringToColor(safeText),
        width: { xs: 32, sm: 44 },
        height: { xs: 32, sm: 44 },
        fontSize: { xs: "0.875rem", sm: "1rem" },
        border: hasImage ? '2px solid rgba(255,255,255,0.18)' : 'none',
        boxShadow: hasImage ? '0 0 12px rgba(0,0,0,0.45)' : 'none',
        overflow: 'hidden'
      }}
      imgProps={{
        onError: (e) => {
          // Hide broken image and show fallback text
          e.target.style.display = 'none'
        }
      }}
      children={`${safeText.toUpperCase().split(" ")[0][0]}`}
    />
  )
}

export default TextAvatar
